import { c as _c } from "react/compiler-runtime";
import { Radio } from '@mui/material';
import { CheckmarkIcon } from './CheckmarkIcon';
export function RadioButton(t0) {
  const $ = _c(5);
  const {
    value
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      padding: 0,
      height: "24px",
      width: "24px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckmarkIcon />;
    t3 = <span />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== value) {
    t4 = <Radio disableRipple={true} sx={t1} value={value} checkedIcon={t2} icon={t3} />;
    $[3] = value;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}